/** @type {import('tailwindcss').Config} */
const colors = require("tailwindcss/colors");
const plugin = require("tailwindcss/plugin");
module.exports = {
  content: [
    "./src/pages/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/components/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/app/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/modules/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/layouts/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/lib/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/hooks/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/utils/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/styles/**/*.{js,ts,jsx,tsx,mdx}",
  ],
  theme: {
    colors: {
      ...colors,
      primary: "#0b304a",
      primaryHover: "#166196",
      secondary: "#8cc63e",
      secondaryHover: "#2192e2",
      tertiary: "#166196",
      white: "#FFFFFF",
      black: "#000000",
      success: "#1B8354",
      success_secondary: "#a4f9ef",
      disabledText: "#9BA0C4",
      disabled: "#CECECE",
      disabled_hover: "#777",
      error: "#FF0000",
      font: "#575757",
      background: "hsl(var(--background))",
      foreground: "hsl(var(--foreground))",
      card: {
        DEFAULT: "hsl(var(--card))",
        foreground: "hsl(var(--card-foreground))",
      },
      popover: {
        DEFAULT: "hsl(var(--popover))",
        foreground: "hsl(var(--popover-foreground))",
      },
      primary_prop: {
        DEFAULT: "hsl(var(--primary))",
        foreground: "hsl(var(--primary-foreground))",
      },
      secondary_prop: {
        DEFAULT: "hsl(var(--secondary))",
        foreground: "hsl(var(--secondary-foreground))",
      },
      muted: {
        DEFAULT: "hsl(var(--muted))",
        foreground: "hsl(var(--muted-foreground))",
      },
      accent: {
        DEFAULT: "hsl(var(--accent))",
        foreground: "hsl(var(--accent-foreground))",
      },
      destructive: {
        DEFAULT: "hsl(var(--destructive))",
        foreground: "hsl(var(--destructive-foreground))",
      },
      border: "hsl(var(--border))",
      input: "hsl(var(--input))",
      ring: "hsl(var(--ring))",
      chart: {
        "1": "hsl(var(--chart-1))",
        "2": "hsl(var(--chart-2))",
        "3": "hsl(var(--chart-3))",
        "4": "hsl(var(--chart-4))",
        "5": "hsl(var(--chart-5))",
      },
      brand: {
        DEFAULT: "hsl(var(--brand))",
        foreground: "hsl(var(--brand-foreground))",
      },
      highlight: {
        DEFAULT: "hsl(var(--highlight))",
        foreground: "hsl(var(--highlight-foreground))",
      },
    },
    fontFamily: {
      sans: ["MainFont", "sans-serif"],
      oswald: ["Oswald", "sans-serif"],
      title: ["Title", "sans-serif"],
    },
    borderRadius: {
      lg: "var(--radius)",
      md: "calc(var(--radius) - 2px)",
      sm: "calc(var(--radius) - 4px)",
    },
  },
  plugins: [
    plugin(function ({ addUtilities, addVariant, theme }: any) {
      addUtilities(
        {
          ".page-title": {
            fontSize: "4rem",
            fontWeight: "700",
            color: theme("colors.black"),
            "@screen md": {
              fontSize: "4.5rem",
            },
          },
          ".slide-title": {
            fontSize: "3.6rem",
            fontWeight: "700",
            color: theme("colors.black"),
            "@screen md": {
              fontSize: "4rem",
            },
          },
          ".desc": {
            fontSize: "1.3rem",
            "@screen md": {
              fontSize: "1.5rem",
            },
          },
        },
        ["responsive"]
      );
      addVariant("child", "& > *");
      addVariant("child-hover", "& > *:hover");
    }),
  ],
};
